<template>
  <router-link to="/" v-if="!isDisabled">
    <v-img :src="require(`@/assets/logos/${filename}`)" contain :width="width" alt="polyticks-logo" height="45" />
  </router-link>
  <div v-else>
    <v-img :src="require(`@/assets/logos/${filename}`)" contain :width="width" alt="polyticks-logo" height="45" />
  </div>
</template>

<script>
export default {
  name: "Logo",

  props: {
    isDisabled: {
      default: false,
    },
    width: {
      default: "130",
    },
    filename: {
      default: "logo-color.svg",
    },
  },
};
</script>
